import React, { useEffect, useRef, useState } from 'react';
import PaymentCard from '../homepage/PaymentCard';
import style from '../../css/homepage/Subscriptionsection.module.css';

const Subscriptionsection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (imageRef.current) {
      observer.observe(imageRef.current);
    }
    return () => {
      if (imageRef.current) observer.unobserve(imageRef.current);
    };
  }, []);

  return (
    <div className="container-fluid">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 d-flex justify-content-center">
            <PaymentCard />
          </div>
          <div className="col-xl-6 text-center">
  <div className={style.subscriptionImageWrapper}>
    <img
      ref={imageRef}
      src="/images/Cyborg-bro.svg"
      alt="Subscription visual"
      className={`${style.subscriptionImage} ${isVisible ? style.animateImage : ''}`}
    />
  </div>
</div>

        </div>
      </div>
    </div>
  );
};

export default Subscriptionsection;
